import React from 'react';
import PropTypes from 'prop-types';
import ProfilePic from "../../../ProfilePic";
import {getStatus} from "../../../../util/utility";
import messaging_utility from "../../../../util/messaging/utility";
import "./index.css";

UserSection.propTypes = {
    broadcaster: PropTypes.object.isRequired,
    selectedChannel: PropTypes.object.isRequired,
};

const getUserType = (member) => {
    return member.metaData.is_user === "True" ? "user" : "broadcaster"
}

function UserSection(props) {

    let member = messaging_utility.retrieveMemberDetails(props,props.selectedChannel);
    if(member.length === 1){
        member = member[0]
    }

    return (
        <div className="direct-messaging-header-user-list-item display-flex-align-center">

            <div className="display-flex-align-center">
                <ProfilePic
                    profile_pic={member.profileUrl}
                    is_verified={member.metaData.is_broadcaster_verified === "1" ? 1 : 0}
                    user_type={getUserType(member)}/>

                <div className="user-list-display-flex-justify-content-flex-start">
                    <div className="broadcaster-profile-container-broadcaster-name">
                        <span className="user-list-username">{member.nickname}</span>
                        <img src={getStatus(member.connectionStatus === "online" ? 1 : 0)} style={{paddingLeft: 5}}
                             alt="user status"/>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UserSection;